module.exports = __webpack_public_path__ + "img/Bodice-Front-B1-Db-Ed.498bff13.png";